<template>
	<v-card>
		<v-card-title>
			<translate>Sigma Threshold</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-text-field
						v-model="search"
						append-inner-icon="$search"
						:label="$gettext('Search')"
						variant="outlined"
						single-line
						hide-details
						clearable
					/>
				</v-col>
				<v-spacer />
			</v-row>
			<v-row>
				<v-col>
					<v-data-table
						ref="sigmaTable"
						:items="items"
						:search="search"
						:headers="tableHeaders"
						:items-per-page-options="[ 10, 50, 100, ]"
						:loading="loading"
						:items-length="totalRows"
					/>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'PricingParameterSigmaThreshold',

	data () {
		return {
			items: [],
			search: null,
			options: {
			},
			loading: false,
			totalRows: null
		};
	},

	computed: {
		tableHeaders () {
			return [
				{
					title: this.$gettext('Series ID'), value: 'seriesId', sortable: false
				},
				{
					title: this.$gettext('Brand ID'), value: 'brandId', sortable: false
				},
				{
					title: this.$gettext('Brand'), value: 'brandName', sortable: false
				},
				{
					title: this.$gettext('Series'), value: 'seriesName', sortable: false
				},
				{
					title: this.$gettext('Series Policy Days'), value: 'seriesPolicyDays', sortable: true
				},
				{
					title: this.$gettext('Active Policy Count'), value: 'activePolicyCount', sortable: false
				},
				{
					title: this.$gettext('Expected Threshold Date'), value: 'expectedThresholdDate', sortable: true
				},
				{
					title: this.$gettext('Series Damage Claim Frequency'), value: 'seriesDamage', sortable: false
				},
				{
					title: this.$gettext('Brand Damage Claim Frequency'), value: 'brandDamage', sortable: false
				},
				{
					title: this.$gettext('Brand price'), value: 'brandPrice', sortable: false
				},
				{
					title: this.$gettext('Series price'), value: 'seriesPrice', sortable: false
				},
			];
		},

		filter () {
			return this.search ? {
				'search': this.search
			} : {
			};
		}
	},

	mounted () {
		this.index();
	},

	methods: {
		/**
		 * Retrieve data for the table
		 */
		index () {
			this.loading = true;
			axios.get('/bo/pricing/sigmathreshold').then(({
				data,
			}) => {
				this.items = data.items ? data.items : data;
				this.totalRows = this.items.length;
				this.loading = false;
			}).catch((error) => {
				window.captureException(error);
				this.loading = false;
			});
		},
	}
};
</script>
